"use client";

import { useEffect } from "react";
import { toast } from "sonner";

function cleanupPaddleQueryParam() {
  const url = new URL(window.location.href);

  if (!url.searchParams.has("_ptxn")) {
    return;
  }

  url.searchParams.delete("_ptxn");
  window.history.replaceState({}, "", url.toString());
}

export default function PaddleCheckoutListener() {
  useEffect(() => {
    const onPaddleEvent = (rawEvent: Event) => {
      const event = (rawEvent as CustomEvent).detail as
        | {
            name?: string;
            data?: Record<string, unknown>;
          }
        | undefined;

      if (!event?.name) return;

      if (event.name === "checkout.completed") {
        window.Paddle?.Checkout?.close?.();
        toast.success("Payment successful. Your plan will update shortly.");
        cleanupPaddleQueryParam();
        window.__orignlyPaddleSessionHandled = true;
      }

      if (event.name === "checkout.closed") {
        window.Paddle?.Checkout?.close?.();
        cleanupPaddleQueryParam();
      }
    };

    window.addEventListener(
      "orignly-paddle-event",
      onPaddleEvent as EventListener
    );

    return () => {
      window.removeEventListener(
        "orignly-paddle-event",
        onPaddleEvent as EventListener
      );
    };
  }, []);

  return null;
}
